import React from "react";

const BLOCK_TYPES = {
  TEXT: "text",
  IMAGE: "image",
  HEADER: "header",
  SECTION: "section",
  BUTTON: "button",
  COLUMNS: "columns",
};

export const PageRenderer = ({ blocks = [] }) => {
  const renderBlock = (block, index) => {
    if (!block) return null;

    switch (block.type) {
      case BLOCK_TYPES.TEXT:
        return (
          <div
            key={block.id || index}
            style={block.styles}
            dangerouslySetInnerHTML={{ __html: block.content }}
          />
        );

      case BLOCK_TYPES.HEADER:
        const HeaderTag = `h${block.level || 1}`;
        return React.createElement(
          HeaderTag,
          {
            key: block.id || index,
            style: block.styles,
          },
          block.content
        );

      case BLOCK_TYPES.IMAGE:
        if (!block.src) return null;
        const imageContainerStyle = {
          textAlign: block.styles?.textAlign || "left",
        };
        const imageStyle = {
          ...block.styles,
          borderRadius: block.styles?.borderRadius || "0px",
          border: block.styles?.border || "none",
          boxShadow: block.styles?.boxShadow || "none",
          width: block.styles?.width || "100%",
          maxWidth: block.styles?.maxWidth || "100%",
          display: "inline-block",
        };
        return (
          <div key={block.id || index} style={imageContainerStyle}>
            <img
              src={block.src}
              alt={block.alt || ""}
              title={block.title || ""}
              style={imageStyle}
            />
          </div>
        );

      case BLOCK_TYPES.BUTTON:
        return (
          <a
            key={block.id || index}
            href={block.link || "#"}
            style={block.styles}
            className="inline-block transition-opacity hover:opacity-80"
          >
            {block.text || "Klikk her"}
          </a>
        );

      case BLOCK_TYPES.SECTION:
        return (
          <section
            key={block.id || index}
            style={{
              backgroundColor: block.backgroundColor,
              padding: block.padding,
            }}
            className="rounded"
          >
            {block.children?.map((child, idx) => renderBlock(child, idx))}
          </section>
        );

      case BLOCK_TYPES.COLUMNS:
        return (
          <div
            key={block.id || index}
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${block.columns || 2}, 1fr)`,
              gap: block.gap || "16px",
            }}
            className="rounded"
          >
            {block.children?.map((column, colIdx) => (
              <div key={colIdx}>
                {column?.map((child, idx) => renderBlock(child, idx))}
              </div>
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  if (!blocks || blocks.length === 0) {
    return (
      <div
        style={{
          padding: 40,
          textAlign: "center",
          background: "#fff",
          border: "1px solid var(--line)",
          borderRadius: 16,
          color: "var(--muted)",
        }}
      >
        Ingen innhold å vise
      </div>
    );
  }

  return (
    <div className="page-content airon-page-content">
      {blocks.map((block, index) => renderBlock(block, index))}
    </div>
  );
};

export default PageRenderer;

